<template>
    <base-tool
        :tool-name="tool.name"
        :tool-description="tool.description"
        @back="goBack"
    >
        <tag-selector
            v-model="selectedTagIds"
            data-testid="communication-tags-tool-selector"
            :multiple="false"
            class="w-100"
            @change="handleTagsChange"
            :category_prop="TagCategory.CAT_COMMUNICATIONS"
            :value="selectedTagIds"
        />
    </base-tool>
</template>

<script>
import BaseTool from './base-tool.vue'
import ToolMixin from './tool-mixin'
import TagSelector from '../../../tag-selector.vue'
import * as TagCategory from '../../../../constants/tag-categories'

export default {
    name: 'CommunicationTagsTool',

    mixins: [ToolMixin],

    components: {
        BaseTool
    },

    props: {
        tool: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            selectedTagIds: [],
            TagCategory,
        }
    },

    methods: {
        handleTagsChange(selectedId) {
            if (!selectedId) {
                this.$emit('communication-tags-selected', [])
                return
            }

            this.$emit('communication-tags-selected', [selectedId])
        },
    },
}
</script>

